import React,{useState, useContext, useLayoutEffect, useEffect} from 'react'
import ELEMENT from './ELEMENT'
import styles from '../css/Form.module.css'
import CSSPreparation from '../../components/Properties/CSSPreparation.jsx'
import { StyleSheet, css } from 'aphrodite'
// import {AppContext} from '../../Resources/CanvasContextFile'
import PrepareCSSClass from '../../components/IFormDesignerLayout/PrepareCSSClass'
import {useDispatch,addContexts,useSelector} from "../../Redux"
import { GetState, GetStateFromData } from '../../components/CustomHooks/CustomHooks.js'
import { getOpenCanvasForPreviewAdvance } from '../../components/IFormDesignerLayout/IFormDesignerLogic.jsx'


const FORM = (props)=> {

    var subFormBackgroundColor;
    subFormBackgroundColor = props.data && props.data.pageStyle && props.data.pageStyle["BackgroundColor"];


    var width = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["width"]
    var paddingValue = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["FormHorizontalAlignmentSpacing"]
    var paddingValueVertical = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["FormVerticalAlignmentSpacing"]
    var height = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["height"]
    var background_color = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["background-color"]
    var border_color = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["border-color"]
    var left = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["left"]
    var top = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["top"]
    var right = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["right"]
    var bottom = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["bottom"]
    var alignself = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["align-self"]
    var marginLeft = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["margin-left"]
    var marginRight = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["margin-right"]
    var marginTop = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["margin-top"]
    var marginBottom = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["margin-bottom"]
    var position = props && props.style &&  Object.keys(props.style).length !== 0 && props.data.style["position"]
    var padding = props && props.style && Object.keys(props.style).length !== 0 && props.data.style["padding"]

   
	const isSubformInPage = props?.isSubformInPage || false;
    
    const [styleData, setStyling]=useState({}); 
    const [preparecss, setpreparecss] = useState(false);
    let centerPage = false;
    let appliedFormHeight = false;
    const [oldStyle, setOldStyle] = useState();
    if(props.data.style !== oldStyle){
        setpreparecss(false);
        setOldStyle(props.data.style);
    }
    var styleSheet = StyleSheet.create({
        styling: styleData
    });

    var styleSheet1 = StyleSheet.create({
        styling: {}
    });

         
    function setStylingData(stylingData) {
        setStyling(stylingData);
        setpreparecss(true)
    }
    const contexts = GetStateFromData(props.containerId);
  const {tempCanHeight,openSubformCheck} = GetState("tempCanHeight","openSubformCheck");
  const openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
    // const AppContextVar = useContext(AppContext);
    const AppContextVar=contexts.contexts;
    var applicationDataVar = contexts?.contexts?.applicationData;
    const {pageHorizontalAlignmentType,pageHorizontalAlignmentValue,pageVerticalAlignmentType,pageVerticalAlignmentValue,setPageHorizontalAlignmentType,setPageVerticalAlignmentType,setPageHorizontalAlignmentValue,setPageVerticalAlignmentValue,formState2,openCanvasForSubform} = contexts.contexts;
    var themeData;
    if(AppContextVar!==undefined){
        if(AppContextVar.formState2){
            themeData = AppContextVar.formState2.theme;
        } 
    }

    useEffect(()=>{
        // setPageHorizontalAlignmentType(themeData.style?.FormHorizontalAlignmentType)
        // setPageVerticalAlignmentType(themeData.style?.FormVerticalAlignmentType)
        // setPageHorizontalAlignmentValue(themeData.style?.FormHorizontalAlignmentSpacing)
        // setPageVerticalAlignmentValue(themeData.style?.FormVerticalAlignmentSpacing)
    },[pageVerticalAlignmentType,pageVerticalAlignmentValue])

    // //  console.log("themeData ", themeData);
    // //  console.log("themeData Custom ", themeData && themeData["CustomStyle"]);

    const data = props.data;
    var inlineFormStyleJson = {
        backgroundColor:subFormBackgroundColor,
        width:width,
        height:data?.id === "FormDef" ? "" : height,
        // ...(height === "100%" ? {} : { height }),
        border:'3px solid '+ border_color,
        // paddingLeft: paddingLeft
        paddingBottom: data?.id === "FormDef" ? "0px" : applicationDataVar?.islogin === "Y" ? formState2.containerControl === "wizard_h" || formState2.containerControl === "Menu" || formState2.containerControl === "wizard_v" || formState2.containerControl === "sidenavigation" ? (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform") ? "100px" : "0px" : "100px" : (props.previewmode) ? "0px" : formState2.containerControl === "wizard_h" || formState2.containerControl === "wizard_v" || formState2.containerControl === "Menu" || formState2.containerControl === "sidenavigation" ? (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform") ? "50px" : "0px" : "50px",
    };
    var formClass;
    //For fixing the UI for FORM and RootControl using different style
    if(data.id==='RootControl'){
        if(props.previewmode===true && !props?.data?.isListview ){
            if(openCanvasForSubform === "advanceListviewFromScratch"){
                formClass = styles.RootControlInPreviewAdv;
            }else{
                formClass = styles.RootControlInPreview;
            }
            
        }else if(props?.data?.isListview){
            formClass = styles.RootControlInPreviewListview;
        }
         else {
            if(openCanvasForSubform === "advanceListviewFromScratch"){
                formClass = styles.RootControlAdv;
            }else{
                formClass = styles.RootControl;
            }
            
            
            // formClass[]
            //  = props.data && props.data.pageStyle && props.data.pageStyle["BackgroundColor"];
        }
    } else if(data.id==='FormDef'){
        
        formClass = styles.form;
        inlineFormStyleJson.height = formState2?.style?.formCustomHeight ? `${formState2?.style?.formCustomHeight}%` : "100%";
        if(formState2?.style?.isFitHeight){
            inlineFormStyleJson.height = ""
        }
        if(formState2?.children[1]?.children.length === 1){
            inlineFormStyleJson.height = "100%";
        }
        if(formState2?.style?.formConfig?.isFullPage){
            inlineFormStyleJson.height = "100%";
        }
        // inlineFormStyleJson.overflow = `auto`;
        // inlineFormStyleJson.overflowX = `hidden`;
    }
    // useEffect(()=>{
    //     if(props.previewmode){
    //         if(window.formLoad){
    //             window.formLoad();
    //         }
    //     }
    // },[])
   
    // const [wizardPresent,setWizardPresent]=useState(false);

    // useEffect(()=>{
    //     if( ( document.querySelector(".wizardMain_Id") || document.querySelector("[control_id=wizard]") ) && wizardPresent===false  ) {
    //         setWizardPresent(true);
    //     }
    //     else if(!document.querySelector(".wizardMain_Id") && !document.querySelector("[control_id=wizard]")  && wizardPresent===true){
    //         setWizardPresent(false);
    //     }
    // })

    
    if(props.data.style?.FormHorizontalAlignmentLeft=== "Left"){
        inlineFormStyleJson.paddingLeft = props.data.style?.horizontalSpacingLeft;
    }
     if(props.data.style?.FormHorizontalAlignmentRight === "Right"){
        inlineFormStyleJson.paddingRight = props.data.style?.horizontalSpacingRight;
    }else if(props.data.style?.FormHorizontalAlignmentCenter === "Center"){
        inlineFormStyleJson.paddingLeft = props.data.style?.horizontalSpacingLeft;
        inlineFormStyleJson.paddingRight = props.data.style?.horizontalSpacingRight;
    }
    
    if(props.data.style?.FormVerticalAlignmentTop=== "Top"){
        inlineFormStyleJson.paddingTop = props.data.style["FormVerticalAlignmentSpacingTop"];
    }if(props.data.style?.FormVerticalAlignmentBottom === "Bottom"){
        inlineFormStyleJson.paddingBottom = props.data.style["FormVerticalAlignmentSpacingBottom"];
    }else if(props.data.style?.FormVerticalAlignmentCenter === "Center"){
        inlineFormStyleJson.display = "absolute"
        inlineFormStyleJson.paddingTop = props.data.style?.FormVerticalAlignmentSpacingTop;
        inlineFormStyleJson.paddingBottom = props.data.style?.FormVerticalAlignmentSpacingBottom;
    }
             
    if(data.ControlType === "form"){
        // inlineFormStyleJson.display= "flex"
        if(formState2?.style?.formConfig?.isFullPage){
            inlineFormStyleJson.paddingBottom = "0px"
        }
        if(openCanvasForSubform){
            inlineFormStyleJson.height = "100%"
        }
    }
    if(data.id==='RootControl' && !openCanvasForSubform && openSubformCheck !=="subform" && openCanvasForPreviewAdvance !== "advanceListviewPopupInPreview" && !props?.data?.isListview){
        inlineFormStyleJson.border= formState2?.style?.formBorderColor ? `1px solid ${formState2?.style?.formBorderColor}` : 'none';
        inlineFormStyleJson.backgroundColor= `${formState2?.style?.formBackgroundColor}`;
        inlineFormStyleJson.width = "100%"
        if(formState2?.style?.formConfig?.isCustom){
            inlineFormStyleJson.width = formState2?.style?.formCustomWidth ? `${formState2?.style?.formCustomWidth}%` :"100%";
            inlineFormStyleJson.maxWidth = formState2?.style?.formCustomMaxWidth ? `${formState2?.style?.formCustomMaxWidth}px` : "";

            if(formState2?.style?.customWidthAlignment === "center"){
                inlineFormStyleJson.marginRight= "auto"
                inlineFormStyleJson.marginLeft= "auto"
            }else if(formState2?.style?.customWidthAlignment === "end"){

                // inlineFormStyleJson.marginRight= "auto"
                if(formState2?.style?.formCustomHorizontalPadding){
                    inlineFormStyleJson.marginRight = `${formState2?.style?.formCustomHorizontalPadding}%`
                }
                inlineFormStyleJson.marginLeft= "auto"
            }else{
                if(formState2?.style?.formCustomHorizontalPadding){
                    inlineFormStyleJson.marginLeft = `${formState2?.style?.formCustomHorizontalPadding}%`
                }
                inlineFormStyleJson.marginRight= "auto"
            }

            if(formState2?.style?.customHeightAlignment === "center"){
                if(formState2?.style?.formCustomHeight){
                    inlineFormStyleJson.height = `${formState2?.style?.formCustomHeight}%`
                    inlineFormStyleJson.minHeight = "0"
                    inlineFormStyleJson.overflow = "auto"
                    inlineFormStyleJson.overflowX = "hidden"
                }
                // centerPage = true
                // inlineFormStyleJson.position = "absolute";
                // inlineFormStyleJson.top = "50%";
                if(formState2?.style?.customWidthAlignment === "center"){
                    inlineFormStyleJson.left = "50%";
                    // inlineFormStyleJson.paddingTop = `${tempCanHeight / 4}px`;
                    // inlineFormStyleJson.paddingBottom = `${tempCanHeight / 4}px`;
                    // inlineFormStyleJson.transform = "translate(-50%, 0%)";

                    // inlineFormStyleJson.transform = "translate(-50%, -50%)";
                }else if(formState2?.style?.customWidthAlignment === "start"){
                    inlineFormStyleJson.left = "0%";
                    // inlineFormStyleJson.transform = "translate(0%, -50%)";
                    // inlineFormStyleJson.paddingTop = `${tempCanHeight / 4}px`
                    // inlineFormStyleJson.paddingBottom = `${tempCanHeight / 4}px`
                }else if(formState2?.style?.customWidthAlignment === "end"){
                    inlineFormStyleJson.right = "0%";
                    // inlineFormStyleJson.transform = "translate(0%, -50%)";
                    // inlineFormStyleJson.paddingTop = `${tempCanHeight / 4}px`
                    // inlineFormStyleJson.paddingBottom = `${tempCanHeight / 4}px`
                }
                
            }else if(formState2?.style?.customHeightAlignment === "top"){
                if(formState2?.style?.formCustomVerticalPadding){
                    inlineFormStyleJson.marginTop = `${formState2?.style?.formCustomVerticalPadding / 2}%`
                }
                if(formState2?.style?.formCustomHeight){
                    inlineFormStyleJson.height = `${formState2?.style?.formCustomHeight}%`
                    inlineFormStyleJson.minHeight = "0"
                    inlineFormStyleJson.overflow = "auto"
                    inlineFormStyleJson.overflowX = "hidden"
                }       
                // inlineFormStyleJson.position = "absolute";
                inlineFormStyleJson.top = AppContextVar?.applicationData?.islogin === "Y" ? "" : "0%";
                if(formState2?.style?.customWidthAlignment === "center"){
                    inlineFormStyleJson.left = "50%";
                    // inlineFormStyleJson.transform = "translate(-50%, 0%)";
                }else if(formState2?.style?.customWidthAlignment === "start"){
                    inlineFormStyleJson.left = "0%";
                    inlineFormStyleJson.transform = "translate(0%, 0%)";
                }else if(formState2?.style?.customWidthAlignment === "end"){
                    inlineFormStyleJson.right = "0%";
                    inlineFormStyleJson.transform = "translate(0%, 0%)";
                }
            }
        }
        if(formState2?.style?.isFitHeight){
            inlineFormStyleJson.height= "";
            inlineFormStyleJson.minHeight = "fit-content"
            if(formState2?.style?.formCustomVerticalPadding){
                inlineFormStyleJson.paddingTop = `${formState2?.style?.formCustomVerticalPadding / 2}% 0px`
            }
        }
        // if(formState2?.style?.isFullPage){
        //     inlineFormStyleJson.hei
        // }
        
        //inlineFormStyleJson.marginTop= '-15px';
        // inlineFormStyleJson.paddingBottom= '0px';
    } else if(data.ControlType==='form' && !openCanvasForSubform && openSubformCheck !=="subform" && openCanvasForPreviewAdvance !== "advanceListviewPopupInPreview"){ 
        inlineFormStyleJson.backgroundColor= background_color;

        if(formState2?.style?.customHeightAlignment === "center" && !formState2?.style?.isFitHeight && formState2?.style?.formCustomHeight && !formState2?.style?.formConfig?.isFullPage){
            inlineFormStyleJson.paddingBottom = "none"
            appliedFormHeight = true
            centerPage = true
        }
        if(formState2?.style?.customHeightAlignment === "top" && !formState2?.style?.isFitHeight && formState2?.style?.formCustomHeight && !formState2?.style?.formConfig?.isFullPage){
           inlineFormStyleJson.paddingBottom = "none"
           appliedFormHeight = true
        }
        if(left){
            // inlineFormStyleJson.left = left;
        }
        if(right){
            // inlineFormStyleJson.right = right
        }
        if(top){
            // inlineFormStyleJson.top = top
        }
        if(bottom){
            // inlineFormStyleJson.bottom = bottom
        }
        if(marginLeft){
            // inlineFormStyleJson.marginLeft = marginLeft
        }
        if(marginRight){
            // inlineFormStyleJson.marginRight = marginRight
        }
        if(marginTop){
            // inlineFormStyleJson.marginTop = marginTop
        }
        if(marginBottom){
            // inlineFormStyleJson.marginBottom = marginBottom
        }
        if(padding){
            // document.getElementById("RootControl").style.padding = "0px"
        }
        // inlineFormStyleJson.height = `calc( 100% - 20px )`;
        // inlineFormStyleJson.paddingTop = "15px";
        // inlineFormStyleJson.minHeight = "200px";
        // inlineFormStyleJson.padding = "0px";
    }
        return (
            <>
			{ preparecss === false 
                ? 
                <CSSPreparation 
                    containerId={props.containerId}
                    stylingData={props.data.style}
                    setStylingData={(stylingData)=> setStylingData(stylingData)}
                /> 
                : 
                null 
            }  
            <div 
                key={data.id}
                id={data.id}
                control_id={data.id}
                elem_type='form'
                data-placement="top"
                frameindex={data.frameIndex}
                style={{
                    ...inlineFormStyleJson, 
                    display: data.id !== "RootControl" ? centerPage ? 'flex' : "" : "",
                    alignItems: data.id !== "RootControl" ? centerPage ? 'center' : "" : "",
                    position: data.id !== "RootControl" ? appliedFormHeight ? 'absolute' : inlineFormStyleJson?.position : "",
                    // paddingTop: data.id === "RootControl" ? "1px" : undefined,
                    paddingBottom: appliedFormHeight ? "0px" : inlineFormStyleJson.paddingBottom,
                    backgroundColor: props?.data?.isListview ? inlineFormStyleJson.backgroundColor : formState2.style.pageBackgroundType === "pageBackgroundColor" ? inlineFormStyleJson.backgroundColor : '',
                }}
                className={ (props.data && props.data.style) ? formClass : [formClass, openCanvasForSubform === "advanceListviewFromScratch" ? css(styleSheet1.styling) : css(styleSheet.styling)].join(" ") }
            >
                <PrepareCSSClass containerId={props.containerId} customCSS={true}  stylingData={themeData?.["CustomStyle"]} />
            
                    {   
                        props.data && props.data.children && props.data.children.map(
                        c =>
                        <ELEMENT isSubformInPage={isSubformInPage} children = {props.data.children} containerId={props.containerId} previewmode={props.previewmode} id={c.id} key={c.id} elem_type={c.elem_type} data={c}                     
                        isSubForm= {props?.isSubForm} buttonId={props?.buttonId} openCanvasForSubform={props.openCanvasForSubform}/>
                        )
                    }
                </div>
            </>
        );
}

export default FORM
